import type { FundraisingStatus } from "@entrilia/shared/api/fundraisingTypes";
import CompleteDialogIcon from "@entrilia/shared/icons/CompleteDialogIcon";
import PublishDialogIcon from "@entrilia/shared/icons/PublishDialogIcon";
import PublishToPreviewDialogIcon from "@entrilia/shared/icons/PublishToPreviewDialogIcon";

interface Props {
  status: FundraisingStatus;
}

const FundraisingStatusUpdateIcon = ({ status }: Props) => {
  switch (status) {
    case "Preview":
      return <PublishToPreviewDialogIcon sx={{ width: 80, height: 80 }} />;
    case "Live":
      return <PublishDialogIcon sx={{ width: 80, height: 80 }} />;
    case "Completed":
      return <CompleteDialogIcon sx={{ width: 80, height: 80 }} />;
    default:
      return null;
  }
};

export default FundraisingStatusUpdateIcon;
